import {
  CARD_CHECKOUT,
  CREATE_OMT_VOUCHER,
  GET_ALL_PROVIDERS_LKP,
  GET_PAYMENT_TRANSACTION,
  MY_MONTY_SEND_OTP,
  MY_MONTY_VERIFY_OTP,
  OMT_CHECKOUT,
  WISH_CHECKOUT,
} from "@api";
import MontyPayLogo from "@assets/Images/MontyPayLogo.webp";
import StatusModal from "@components/StatusModal/StatusModal";
import WalletCard from "@components/WalletCard";
import { ContentCopyTwoTone } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Card,
  Collapse,
  FormHelperText,
  Grid2,
  IconButton,
  InputAdornment,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { version as appVersion } from "../../../package.json";
import "./Checkout.scss";

const MY_MONTY_DIAL_CODE = "961";

const getPayerLocalNumber = (payerPhone) => {
  const phone = String(payerPhone ?? "");
  return phone.startsWith(MY_MONTY_DIAL_CODE)
    ? phone.slice(MY_MONTY_DIAL_CODE.length)
    : "";
};

const CheckoutPage = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedAgentValue, setSelectedAgentValue] = useState("");
  const [showMobileNumber, setShowMobileNumber] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [showInfo, setShowInfo] = useState(true);
  const [loading, setLoading] = useState(false);
  const [mainLoader, setMainLoader] = useState(true);
  const [counter, setCounter] = useState(0);
  const [startCountdown, setStartCountdown] = useState(false);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState("");
  const [walletsData, setWalletsData] = useState([]);
  const [walletProviders, setWalletProviders] = useState([]);
  const [agentProviders, setAgentProviders] = useState([]);
  const [transactionId, setTransactionId] = useState("");
  const [error, setError] = useState("");
  const [orderId, setOrderId] = useState("");
  const [description, setDescription] = useState("");
  const [disableOTP, setDisableOTP] = useState(false);
  const [cancelURL, setCancelURL] = useState("");
  const [wishLoading, setWishLoading] = useState(false);
  const [omtOffLoading, setOmtOffLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [otherOptschecked, setOtherOptsChecked] = useState(false);
  const [showOtherOpts, setShowOtherOpts] = useState(false);
  const [showOtherMobileNumber, setShowOtherMobileNumber] = useState(false);
  const [showOrderId, setShowOrderId] = useState(false);
  const [paymentOrderId, setPaymentOrderId] = useState(false);
  const [paidTrxMsg, setPaidTrxMsg] = useState("");
  const [showMessage, setShowMessage] = useState("");
  const [myMontyDisabled, setMyMontyDisabled] = useState(false);
  const [wishDisabled, setWishDisabled] = useState(false);
  const [omtOffDisabled, setOmtOffDisabled] = useState(false);
  const [showInvalidTrx, setShowInvalidTrx] = useState(false);
  const [countryCode, setCountryCode] = useState("lb");
  const [dialCode, setDialCode] = useState("");
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [cardChecked, setCardChecked] = useState(false);
  const [cardLoading, setCardLoading] = useState(false);
  const [cardDisabled, setCardDisabled] = useState(false);
  const [cardCheckoutUrl, setCardCheckoutUrl] = useState("");
  const [showCardIframe, setShowCardIframe] = useState(false);
  const [cardProvider, setCardProvider] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [successUrl, setSuccessUrl] = useState("");
  const [redirectCountdown, setRedirectCountdown] = useState(0);
  const [payerPhone, setPayerPhone] = useState("");
  const [otpPhone, setOtpPhone] = useState(null);
  const [FormData, SetFormData] = useState({
    mobileNumber: null,
    otp: null,
  });
  console.log("test");
  const isInitialRender = useRef(true);
  //testttt
  useEffect(() => {
    if (isInitialRender.current) {
      const queryParams = new URLSearchParams(window.location.search);
      const transactionGuid = queryParams.get("Id");
      const brand = queryParams.get("brand");

      if (brand === "My_MONTY") {
        setBrandFilter("My_MONTY");
      } else if (brand === "OMT_CASH") {
        setBrandFilter("OMT_CASH");
      }
      if (transactionGuid) {
        getPaymentTransaction(transactionGuid);
      } else {
        setShowInvalidTrx(true);
        setMainLoader(false);
      }
      isInitialRender.current = false;
    }
  }, []);

  const getPaymentTransaction = async (transactionGuid) => {
    try {
      let response = await GET_PAYMENT_TRANSACTION(transactionGuid);
      if (response?.data?.success) {
        // Check if transaction status is Success and redirect to successUrl
        if (response?.data?.data?.status === "Success") {
          const successUrl = response?.data?.data?.successUrl;
          if (successUrl) {
            window.location.href = successUrl;
            return;
          }
        }

        setAmount(response?.data?.data?.amount);
        setCurrency(response?.data?.data?.currency);
        setTransactionId(response?.data?.data?.transactionGuid);
        setOrderId(response?.data?.data?.externalId);
        setDescription(response?.data?.data?.description);
        setCancelURL(response?.data?.data?.failedUrl);
        setSuccessUrl(response?.data?.data?.successUrl || "");
        setPayerPhone(response?.data?.data?.payerPhone || "");
        getProviderLookup(transactionGuid, response?.data?.data?.payerPhone);
        setShowInvalidTrx(false);
      }
    } catch (e) {
      if (e?.status == 400) {
        setShowInvalidTrx(true);
      }
    }
  };

  const getProviderLookup = async (transactionId, payerPhone) => {
    setMainLoader(true);
    try {
      let response = await GET_ALL_PROVIDERS_LKP(transactionId);
      const allProviders = response?.data?.data?.providers || [];
      const wallets = allProviders.filter(
        (provider) => provider.type === "E_WALLET"
      );
      const agents = allProviders.filter(
        (provider) => provider.type === "AGENT_PAYMENT_PROVIDER"
      );
      const card = allProviders.find(
        (provider) => provider.type === "CARD_PAYMENT"
      );
      setWalletProviders(wallets);
      setAgentProviders(agents);
      setCardProvider(card || null);
      setWalletsData(allProviders);
      setShowOtherOpts(agents.length > 0);

      // Auto-select My Monty if brand filter is set
      const queryParams = new URLSearchParams(window.location.search);
      const brand = queryParams.get("brand");
      if (brand === "My_MONTY") {
        const myMontyWallet = wallets.find((w) => w.tag === "MY_MONTY");
        if (myMontyWallet) {
          setSelectedValue("my_monty");
          setChecked(true);
          setShowMobileNumber(true);
          setShowOtp(false);
          autoSendMyMontyOtp(myMontyWallet.recordGuid, transactionId, payerPhone);
        }
      } else if (brand === "OMT_CASH") {
        const omtAgent = agents.find((a) => a.tag === "OMT");
        if (omtAgent) {
          setOtherOptsChecked(true);
          setSelectedAgentValue("agent_omt");
          setShowOtherMobileNumber(true);
          setShowOrderId(false);
          setShowMobileNumber(false);
        }
      }

      setMainLoader(false);
    } catch (e) {
      console.log("e:", e);
      setMainLoader(false);
    }
  };

  const getProviderImage = (provider) => {
    if (provider.logo) {
      const baseURL = import.meta.env.VITE_STATIC_IMAGE_BASE_URL;
      return provider.logo.startsWith("http")
        ? provider.logo
        : `${baseURL}${provider.logo}`;
    }
    return null; // or return a default placeholder image if needed
  };

  const isProviderDisabled = (tag) => {
    if (tag === "MY_MONTY") return myMontyDisabled;
    if (tag === "WHISH") return wishDisabled;
    if (tag === "OMT") return omtOffDisabled;
    return false;
  };

  const isProviderLoading = (tag) => {
    if (tag === "MY_MONTY") return loading;
    if (tag === "WHISH") return wishLoading;
    if (tag === "OMT") return omtOffLoading;
    return false;
  };

  const sendMyMontyOtp = async ({ recordGuid, phoneNumber, countryCode, trxId }) => {
    setDisableOTP(true);
    setLoading(true);
    setWishDisabled(true);
    setMyMontyDisabled(true);
    setOmtOffDisabled(true);
    setCardDisabled(true);
    const data = {
      EWalletRecordGuid: recordGuid,
      PhoneNumber: phoneNumber,
      CountryCode: countryCode,
      TransactionId: trxId,
    };
    let sent = false;
    try {
      let response = await MY_MONTY_SEND_OTP(data);
      if (response?.data?.success == true) {
        sent = true;
        setOtpPhone({ phoneNumber, countryCode });
        setShowOtp(true);
        setShowMobileNumber(false);
        setCounter(30);
        setStartCountdown(true);
        setIsResendEnabled(false);
        setLoading(false);
        setDisableOTP(false);
        setError(false);
        setShowErrorMsg(false);
      } else if (response?.data?.success == false) {
        setShowErrorMsg(true);
        setShowOtp(false);
        setShowMobileNumber(true);
        setStartCountdown(false);
        setIsResendEnabled(false);
        setLoading(false);
        setDisableOTP(false);
        setError(response?.data?.message);
      }
      setWishDisabled(false);
      setMyMontyDisabled(false);
      setOmtOffDisabled(false);
      setCardDisabled(false);
    } catch (e) {
      if (e?.status == 400) {
        setError(e?.response?.data?.message);
        setShowErrorMsg(true);
      }
      setLoading(false);
      setDisableOTP(false);
      setWishDisabled(false);
      setMyMontyDisabled(false);
      setOmtOffDisabled(false);
      setCardDisabled(false);
    }
    return sent;
  };

  const handleOtpSend = () => {
    if (FormData?.mobileNumber === "") {
      setShowErrorMsg(true);
      setError("Mobile Number is required");
      return;
    }
    setShowErrorMsg(false);
    setError("");
    const filteredData = walletsData.filter((item) => item.tag == "MY_MONTY");
    sendMyMontyOtp({
      recordGuid: filteredData[0]?.recordGuid,
      phoneNumber: FormData?.mobileNumber,
      countryCode: dialCode,
      trxId: transactionId,
    });
  };

  // Sends the OTP straight to payerPhone so the customer skips the mobile number step
  const autoSendMyMontyOtp = async (recordGuid, trxId, phone) => {
    const localNumber = getPayerLocalNumber(phone);
    if (!localNumber) return;
    if (startCountdown) {
      setShowMobileNumber(false);
      setShowOtp(true);
      return;
    }
    setShowMobileNumber(false);
    const sent = await sendMyMontyOtp({
      recordGuid,
      phoneNumber: localNumber,
      countryCode: MY_MONTY_DIAL_CODE,
      trxId,
    });
    if (!sent) {
      // fall back to the mobile number step so the customer can type a number
      setShowMobileNumber(true);
      setShowOtp(false);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setWishDisabled(true);
    setMyMontyDisabled(true);
    setOmtOffDisabled(true);
    setCardDisabled(true);
    const filteredData = walletsData.filter((item) => item.tag === "MY_MONTY");
    if (FormData?.otp === "") {
      setError("OTP is required");
      setLoading(false);
      setWishDisabled(false);
      setMyMontyDisabled(false);
      setOmtOffDisabled(false);
      setCardDisabled(false);
      return;
    } else {
      const data = {
        EWalletRecordGuid: filteredData[0]?.recordGuid,
        otp: FormData?.otp,
        TransactionId: transactionId,
      };
      try {
        let response = await MY_MONTY_VERIFY_OTP(data);
        if (response?.status === 200) {
          const checkoutUrl = response?.data?.data?.redirectUrl;
          if (checkoutUrl) {
            window.location.href = checkoutUrl;
            setTimeout(() => {
              setLoading(false);
              setWishDisabled(false);
              setMyMontyDisabled(false);
              setOmtOffDisabled(false);
              setCardDisabled(false);
            }, 3000);
          }
        } else {
          setLoading(false);
          setWishDisabled(false);
          setMyMontyDisabled(false);
          setOmtOffDisabled(false);
          setCardDisabled(false);
        }
      } catch (e) {
        setLoading(false);
        setWishDisabled(false);
        setMyMontyDisabled(false);
        setOmtOffDisabled(false);
        setCardDisabled(false);
        if (e?.status == 400) {
          setError(e?.response?.data?.message);
        }
      }
    }
  };

  useEffect(() => {
    let timer;
    if (startCountdown && counter > 0) {
      timer = setInterval(
        () => setCounter((prevCounter) => prevCounter - 1),
        1000
      );
      setDisableOTP(true);
    }
    if (counter === 0 && startCountdown) {
      setIsResendEnabled(true);
      setStartCountdown(false);
      setDisableOTP(false);
    }
    return () => clearInterval(timer);
  }, [counter, startCountdown]);

  useEffect(() => {
    if (redirectCountdown <= 0) return;
    const timer = setTimeout(() => {
      if (redirectCountdown === 1) {
        window.location.href = successUrl;
      } else {
        setRedirectCountdown((prev) => prev - 1);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [redirectCountdown, successUrl]);

  const handleResend = () => {
    setCounter(30);
    setIsResendEnabled(false);
    const filteredData = walletsData.filter((item) => item.tag === "MY_MONTY");
    sendMyMontyOtp({
      recordGuid: filteredData[0]?.recordGuid,
      trxId: transactionId,
      ...otpPhone,
    });
  };

  const infoHandle = () => {
    setShowInfo(!showInfo);
  };

  const handleChange = (event) => {
    SetFormData(() => ({ mobileNumber: "", otp: "" }));
    setError("");
    const value = event.target.value;
    const isAgentProvider = value.startsWith("agent_");
    const selectedTag = isAgentProvider
      ? value.replace("agent_", "").toUpperCase()
      : value.toUpperCase();
    if (!isAgentProvider) {
      setSelectedValue(event.target.value);
      setSelectedAgentValue("");
      // close card iframe if open when switching to wallet
      setShowCardIframe(false);
      setCardCheckoutUrl("");
      // uncheck card radio visually
      setCardChecked(false);
      setError("");
      setLoading(false);
      setChecked(true);
      setOtherOptsChecked(false);
      if (selectedTag === "MY_MONTY") {
        setShowMobileNumber(true);
        setShowOtp(false);
        setOtherOptsChecked(false);
        setShowOtherMobileNumber(false);
        setShowOrderId(false);
        const myMontyWallet = walletsData.find((item) => item.tag === "MY_MONTY");
        autoSendMyMontyOtp(myMontyWallet?.recordGuid, transactionId, payerPhone);
      } else if (selectedTag === "WHISH") {
        setShowMobileNumber(false);
        setShowOtp(false);
        handleWishCheckout();
        setOtherOptsChecked(false);
      } else if (selectedTag === "OMT") {
        setShowMobileNumber(false);
        setShowOtp(false);
        handleOmtCheckout();
        setOtherOptsChecked(false);
      } else {
        setShowMobileNumber(false);
        setShowOtp(false);
      }
    } else if (isAgentProvider) {
      setSelectedAgentValue(event.target.value);
      setSelectedValue("");
      // close card iframe if open when switching to agent/wallets
      setShowCardIframe(false);
      setCardCheckoutUrl("");
      // uncheck card radio visually
      setCardChecked(false);
      setOtherOptsChecked(true);
      setChecked(false);
      setShowOtherMobileNumber(true);
      setShowOrderId(false);
      setShowMobileNumber(false);
    }
  };

  const handleWishCheckout = async () => {
    setWishDisabled(true);
    setWishLoading(true);
    setMyMontyDisabled(true);
    setOmtOffDisabled(true);
    setCardDisabled(true);
    const filteredData = walletsData?.filter((item) => item?.tag === "WHISH");
    const data = {
      EWalletRecordGuid: filteredData[0]?.recordGuid,
      TransactionId: transactionId,
    };
    try {
      let response = await WISH_CHECKOUT(data);
      if (response?.data?.success) {
        const checkoutUrl = response?.data?.data?.url;
        if (checkoutUrl) {
          window.location.href = checkoutUrl;
          setTimeout(() => {
            setWishDisabled(false);
            setWishLoading(false);
            setMyMontyDisabled(false);
            setOmtOffDisabled(false);
            setCardDisabled(false);
          }, 3000);
        }
      } else {
        setWishDisabled(false);
        setWishLoading(false);
        setMyMontyDisabled(false);
        setOmtOffDisabled(false);
        setCardDisabled(false);
      }
    } catch (e) {
      console.log("e:", e);
      setWishDisabled(false);
      setWishLoading(false);
      setMyMontyDisabled(false);
      setOmtOffDisabled(false);
      setCardDisabled(false);
    }
  };

  const handleOmtCheckout = async () => {
    setOmtOffDisabled(true);
    setOmtOffLoading(true);
    setMyMontyDisabled(true);
    setWishDisabled(true);
    setCardDisabled(true);
    const filteredData = walletsData?.filter((item) => item?.tag === "OMT");
    const data = {
      EWalletRecordGuid: filteredData[0]?.recordGuid,
      TransactionId: transactionId,
    };
    try {
      let response = await OMT_CHECKOUT(data);
      if (response?.data?.success) {
        const checkoutUrl = response?.data?.data?.url;
        if (checkoutUrl) {
          window.location.href = checkoutUrl;
          setTimeout(() => {
            setOmtOffDisabled(false);
            setOmtOffLoading(false);
            setMyMontyDisabled(false);
            setWishDisabled(false);
            setCardDisabled(false);
          }, 3000);
        }
      } else {
        setOmtOffDisabled(false);
        setOmtOffLoading(false);
        setMyMontyDisabled(false);
        setWishDisabled(false);
        setCardDisabled(false);
      }
    } catch (e) {
      console.log("e:", e);
      setOmtOffDisabled(false);
      setOmtOffLoading(false);
      setMyMontyDisabled(false);
      setWishDisabled(false);
      setCardDisabled(false);
    }
  };

  const handleCardCheckout = async () => {
    setCardDisabled(true);
    setCardLoading(true);
    setWishDisabled(true);
    setMyMontyDisabled(true);
    setOmtOffDisabled(true);

    const data = {
      TransactionId: transactionId,
      EWalletRecordGuid: cardProvider?.recordGuid,
    };

    try {
      let response = await CARD_CHECKOUT(data);
      if (response?.data?.success) {
        const checkoutUrl = response?.data?.data?.url;
        if (checkoutUrl) {
          setCardCheckoutUrl(checkoutUrl);
          setShowCardIframe(true);
          setCardDisabled(false);
          setCardLoading(false);
          setWishDisabled(false);
          setMyMontyDisabled(false);
          setOmtOffDisabled(false);
        }
      } else {
        setCardDisabled(false);
        setCardLoading(false);
        setWishDisabled(false);
        setMyMontyDisabled(false);
        setOmtOffDisabled(false);
      }
    } catch (e) {
      console.log("e:", e);
      setCardDisabled(false);
      setCardLoading(false);
      setWishDisabled(false);
      setMyMontyDisabled(false);
      setOmtOffDisabled(false);
    }
  };

  const handleCancelURL = () => {
    window.location.href = cancelURL;
  };

  const handleRadioChange = (event) => {
    SetFormData(() => ({ mobileNumber: "", otp: "" }));
    setError("");
    setShowOtherMobileNumber(false);

    if (event.target.value === "card") {
      setCardChecked(true);
      setChecked(false);
      setOtherOptsChecked(false);
      setSelectedValue("");
      setSelectedAgentValue("");
      setShowMobileNumber(false);
      setShowOtherMobileNumber(false);
      handleCardCheckout();
    } else if (event.target.value === "otherOptions") {
      setCardChecked(false);
      setChecked(false);
      // switching away from card: close card iframe if open
      setShowCardIframe(false);
      setCardCheckoutUrl("");
      // do NOT auto-select the first agent provider; open the section collapsed
      setSelectedValue("");
      setSelectedAgentValue("");
      setShowMobileNumber(false);
      setShowOtherMobileNumber(false);
      setOtherOptsChecked(event.target.checked);
    } else {
      setCardChecked(false);
      setChecked(event.target.checked);
      setOtherOptsChecked(false);
      // switching to wallet option: ensure card iframe is closed
      setShowCardIframe(false);
      setCardCheckoutUrl("");
      // do NOT auto-select the first wallet provider; open the section collapsed
      setSelectedValue("");
      setSelectedAgentValue("");
      setShowMobileNumber(false);
      setShowOtherMobileNumber(false);
    }
  };

  const handleOtherSubmit = async () => {
    setOmtOffLoading(true);
    setWishDisabled(true);
    setMyMontyDisabled(true);
    setOmtOffDisabled(true);
    setCardDisabled(true);
    const data = {
      OrderId: transactionId,
      PhoneNumber: FormData?.mobileNumber,
      PhoneCountryCode: dialCode,
    };
    if (FormData?.mobileNumber === "") {
      setError("Mobile Number is required");
      setShowErrorMsg(true);
      setLoading(false);
      setOmtOffLoading(false);
      return;
    } else {
      try {
        let response = await CREATE_OMT_VOUCHER(data);
        if (response?.status === 200) {
          const referenceNumber = response?.data?.data?.referenceNumber;
          if (referenceNumber) {
            setOmtOffLoading(false);
            setWishDisabled(false);
            setMyMontyDisabled(false);
            setCardDisabled(false);
            setShowOrderId(true);
            setShowOtherMobileNumber(false);
            setPaymentOrderId(referenceNumber);
            setPaidTrxMsg("");
            setShowMessage(false);
            setShowErrorMsg(false);
            if (brandFilter === "OMT_CASH") {
              setRedirectCountdown(15);
            }
          } else {
            setOmtOffLoading(false);
            setWishDisabled(false);
            setMyMontyDisabled(false);
            setOmtOffDisabled(false);
            setCardDisabled(false);
            setShowOrderId(false);
            setPaymentOrderId("");
            setPaidTrxMsg(response?.data?.message);
            setShowMessage(true);
            setShowErrorMsg(true);
            setError(response?.data?.message);
          }
        } else {
          setOmtOffLoading(false);
          setWishDisabled(false);
          setMyMontyDisabled(false);
          setOmtOffDisabled(false);
          setCardDisabled(false);
          setShowOrderId(false);
          setPaymentOrderId("");
          setShowInvalidTrx(false);
          setShowMessage(false);
        }
      } catch (e) {
        setOmtOffLoading(false);
        setWishDisabled(false);
        setMyMontyDisabled(false);
        setOmtOffDisabled(false);
        setCardDisabled(false);
        if (e?.status == 400) {
          setError(e?.response?.data?.message);
          setShowErrorMsg(true);
        }
      }
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(paymentOrderId);
  };

  const handlePhoneChange = (phone, country) => {
    const dialCode = country.dialCode;
    const formattedPhone = phone.startsWith("+") ? phone.slice(1) : phone;
    SetFormData((prev) => ({ ...prev, mobileNumber: formattedPhone }));
    setCountryCode(country.countryCode);
    setDialCode(dialCode);
  };

  const isMyMontyBrand = brandFilter === "My_MONTY";
  const isOmtCashBrand = brandFilter === "OMT_CASH";
  //test
  return (
    <>
      {mainLoader && (
        <Grid2
          size={12}
          display={"flex"}
          height="90vh"
          alignContent={"center"}
          justifyContent={"center"}
          alignItems={"center"}
          alignSelf={"center"}
        >
          <Typography variant="h4">Loading....</Typography>
        </Grid2>
      )}
      {!mainLoader && (
        <Grid2
          container
          direction="column"
          alignItems="stretch"
          justifyContent="flex-start"
          margin="0 auto"
          minHeight={"100vh"}
          maxWidth="600px"
          width="100%"
          sx={{ gap: 2 }}
        >
          {!showMessage && !showInvalidTrx && (
            <>
              <Grid2 size={12} className="header" display={"flex"}>
                <Grid2 size={6} display={"flex"} justifyContent={"start"}>
                  <img
                    src={MontyPayLogo}
                    alt="Monty Pay Logo"
                    width="145.3px"
                    height="26.2px"
                  ></img>
                </Grid2>
                {!showInvalidTrx && (
                  <Grid2 size={6} display="flex" justifyContent={"end"}>
                    <Grid2 container sx={{ gap: 2 }}>
                      {/* <InfoIcon
                        sx={{ width: 20, height: 20, cursor: "pointer" }}
                        className="image"
                        onClick={infoHandle}
                      /> */}
                      {cancelURL !== "" && !isOmtCashBrand && (
                        <>
                          <span
                            style={{
                              cursor: "pointer",
                              color: "white",
                              fontSize: "12px",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                            onClick={handleCancelURL}
                          >
                            Cancel Payment
                            <CloseIcon
                              sx={{ color: "white", fontSize: "16px" }}
                            />
                          </span>
                        </>
                      )}
                    </Grid2>
                  </Grid2>
                )}
              </Grid2>
              {!showInvalidTrx && (
                <>
                  <Collapse in={showInfo} timeout={500}>
                    <Grid2 size={12} paddingLeft={"1em"}>
                      <Grid2>
                        <Grid2
                          container
                          sx={{ gap: 1 }}
                          display={"flex"}
                          justifyContent={"start"}
                          alignItems={"center"}
                          alignSelf={"center"}
                        >
                          <Typography variant="body1">Order:</Typography>
                          <Typography variant="body2">{orderId} </Typography>
                        </Grid2>
                      </Grid2>
                      <Grid2>
                        <Grid2
                          container
                          sx={{ gap: 1 }}
                          display={"flex"}
                          justifyContent={"start"}
                          alignItems={"center"}
                          alignSelf={"center"}
                        >
                          <Typography variant="body2">
                          <Typography component="span" variant="body1">
                            Description:{" "}
                          </Typography>
                          {description}
                        </Typography>
                        </Grid2>
                      </Grid2>
                      <Grid2>
                        <Grid2
                          container
                          sx={{ gap: 1 }}
                          display={"flex"}
                          justifyContent={"start"}
                          alignItems={"center"}
                          alignSelf={"center"}
                        >
                          <Typography variant="body1">Amount:</Typography>
                          <Typography variant="body2">
                            {amount} {currency}
                          </Typography>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </Collapse>
                  <hr style={{ width: "100%", color: "grey" }} />

                  {!isMyMontyBrand && !isOmtCashBrand && (
                    <Typography variant="body1" style={{ marginLeft: "19px" }}>
                      Please choose payment method:
                    </Typography>
                  )}
                  {/* Card Payment Option */}
                  {!isMyMontyBrand && !isOmtCashBrand && cardProvider && (
                    <Grid2
                      size={12}
                      paddingLeft={"1em"}
                      display={"flex"}
                      alignItems="center"
                    >
                      <Radio
                        checked={cardChecked}
                        onChange={handleRadioChange}
                        value="card"
                        name="payment-radio"
                        disabled={cardDisabled}
                      />
                      {/* <CreditCardIcon sx={{ mr: 1, color: "#1976d2" }} /> */}
                      <Typography variant="body3">Card Payment</Typography>
                      {cardLoading && (
                        <Typography variant="body2" sx={{ ml: 2 }}>
                          Loading...
                        </Typography>
                      )}
                    </Grid2>
                  )}

                  {!isMyMontyBrand &&
                    !isOmtCashBrand &&
                    cardChecked &&
                    showCardIframe &&
                    cardCheckoutUrl && (
                      <Grid2 size={12} sx={{ px: { xs: "16px", sm: "50px" } }}>
                        <Card className="card-iframe-container">
                          <Box
                            sx={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              position: "relative",
                            }}
                          >
                            <IconButton
                              onClick={() => {
                                setShowCardIframe(false);
                                setCardCheckoutUrl("");
                              }}
                              sx={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                zIndex: 10,
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                            <iframe
                              src={cardCheckoutUrl}
                              style={{
                                width: "100%",
                                height: "600px",
                                border: "none",
                               // flex: 1,
                              }}
                              title="Card Checkout"
                            />
                          </Box>
                        </Card>
                      </Grid2>
                    )}

                  {/* Wallets Section */}
                  {!isMyMontyBrand &&
                    !isOmtCashBrand &&
                    walletProviders.length > 0 && (
                      <Grid2
                        size={12}
                        paddingLeft={"1em"}
                        display={"flex"}
                        alignItems="center"
                      >
                        <Radio
                          checked={checked}
                          onChange={handleRadioChange}
                          value="wallet"
                          name="payment-radio"
                          disabled={false}
                        />
                        <Typography variant="body3">Wallets</Typography>
                      </Grid2>
                    )}
                  {!isOmtCashBrand &&
                    (isMyMontyBrand || checked) &&
                    (isMyMontyBrand
                      ? walletProviders.filter((p) => p.tag === "MY_MONTY")
                      : walletProviders
                    ).map((provider) => (
                      <Grid2
                        key={provider.recordGuid}
                        size={12}
                        sx={{
                          px: isMyMontyBrand ? "0" : { xs: "16px", sm: "50px" },
                        }}
                      >
                        <WalletCard
                          disabled={isProviderDisabled(provider.tag)}
                          image={getProviderImage(provider)}
                          value={provider.tag.toLowerCase()}
                          checked={selectedValue === provider.tag.toLowerCase()}
                          onChange={handleChange}
                          loading={isProviderLoading(provider.tag)}
                        />

                        {provider.tag.toLowerCase() === "my_monty" &&
                          selectedValue === provider.tag.toLowerCase() && (
                            <>
                              {showMobileNumber && !showOtp && (
                                <Card className="myMonty-card">
                                  <Grid2 container sx={{ gap: 2 }} width="80%">
                                    <Grid2
                                      size={12}
                                      display={"flex"}
                                      justifyContent={"start"}
                                    >
                                      <Typography
                                        className="title"
                                        variant="body6"
                                        marginBottom={"3px"}
                                      >
                                        Enter Mobile Number
                                      </Typography>
                                    </Grid2>
                                    <Grid2 size={12}>
                                      <Box>
                                        <div className="phone-input-container">
                                          <PhoneInput
                                            country={countryCode}
                                            countryCodeEditable={false}
                                            value={FormData.mobileNumber || ""}
                                            onChange={handlePhoneChange}
                                            inputStyle={{ width: "100%" }}
                                            specialLabel=""
                                            searchNotFound={
                                              "No Country Found!!"
                                            }
                                            enableSearch={true}
                                            placeholder="Mobile Number"
                                          />
                                        </div>
                                        {showErrorMsg && (
                                          <FormHelperText className="error-styling">
                                            {error}
                                          </FormHelperText>
                                        )}
                                      </Box>
                                    </Grid2>
                                    <Grid2 size={12}>
                                      <Button
                                        fullWidth
                                        disabled={loading}
                                        id="signIn"
                                        onClick={
                                          showMobileNumber
                                            ? handleOtpSend
                                            : handleSubmit
                                        }
                                        className="submitBtn"
                                      >
                                        {loading ? "Loading..." : "Submit"}
                                      </Button>
                                    </Grid2>
                                  </Grid2>
                                </Card>
                              )}

                              {!showMobileNumber && showOtp && (
                                <Card className="myMonty-card">
                                  <Box margin={"0 auto"} width={"80%"}>
                                    <Grid2 container sx={{ gap: 2 }}>
                                      <Grid2
                                        size={12}
                                        display={"flex"}
                                        justifyContent={"start"}
                                      >
                                        <Typography
                                          className="title"
                                          variant="body6"
                                          marginBottom={"3px"}
                                        >
                                          Enter OTP received on Mobile Number
                                        </Typography>
                                      </Grid2>
                                      <Grid2 size={12}>
                                        <TextField
                                          fullWidth
                                          className="login-text-field"
                                          placeholder="OTP"
                                          id="otp"
                                          name="otp"
                                          value={FormData.otp || ""}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            const numericValue = value.replace(
                                              /\D/g,
                                              ""
                                            );
                                            if (numericValue.length > 0) {
                                              SetFormData((prev) => ({
                                                ...prev,
                                                otp: numericValue,
                                              }));
                                            } else {
                                              SetFormData((prev) => ({
                                                ...prev,
                                                otp: "",
                                              }));
                                            }
                                          }}
                                          helperText={error}
                                          error={error && Boolean(error)}
                                        />
                                      </Grid2>
                                      <Grid2 size={12}>
                                        <Button
                                          fullWidth
                                          disabled={loading}
                                          id="signIn"
                                          onClick={
                                            showMobileNumber
                                              ? handleOtpSend
                                              : handleSubmit
                                          }
                                          className="submitBtn"
                                        >
                                          {loading ? "Loading..." : "Submit"}
                                        </Button>
                                      </Grid2>
                                      <Grid2 size={12}>
                                        <Grid2 container sx={{ gap: 3 }}>
                                          <Grid2 size={12} display={"flex"}>
                                            <Typography
                                              className={
                                                isResendEnabled
                                                  ? "link"
                                                  : "non-link"
                                              }
                                              variant="body6"
                                              onClick={
                                                disableOTP ? null : handleResend
                                              }
                                            >
                                              Resend OTP
                                            </Typography>
                                            <Typography
                                              className="counter"
                                              sx={{
                                                ml: 1,
                                                cursor: isResendEnabled
                                                  ? "pointer"
                                                  : "not-allowed",
                                                color: isResendEnabled
                                                  ? "primary.main"
                                                  : "grey.500",
                                                pointerEvents: isResendEnabled
                                                  ? "auto"
                                                  : "none",
                                                textDecoration: "none",
                                              }}
                                            >
                                              {isResendEnabled
                                                ? "0"
                                                : `in ${counter}s`}
                                            </Typography>
                                          </Grid2>
                                        </Grid2>
                                      </Grid2>
                                    </Grid2>
                                  </Box>
                                </Card>
                              )}
                            </>
                          )}
                      </Grid2>
                    ))}
                </>
              )}
              {showOtherOpts && !isMyMontyBrand && (
                <>
                  {!isOmtCashBrand && (
                    <Grid2
                      size={12}
                      paddingLeft={"1em"}
                      display={"flex"}
                      alignItems="center"
                    >
                      <Radio
                        checked={otherOptschecked}
                        onChange={handleRadioChange}
                        value="otherOptions"
                        name="payment-radio"
                        disabled={false}
                      />
                      <Typography variant="body3">Cash at Agent</Typography>
                    </Grid2>
                  )}
                  {(isOmtCashBrand || otherOptschecked) &&
                    (isOmtCashBrand
                      ? agentProviders.filter((a) => a.tag === "OMT")
                      : agentProviders
                    ).map((provider) => (
                      <Grid2
                        key={provider.recordGuid}
                        size={12}
                        sx={{
                          px: isOmtCashBrand ? "0" : { xs: "16px", sm: "50px" },
                        }}
                      >
                        <WalletCard
                          disabled={omtOffDisabled}
                          image={getProviderImage(provider)}
                          value={`agent_${provider.tag.toLowerCase()}`}
                          checked={
                            selectedAgentValue ===
                            `agent_${provider.tag.toLowerCase()}`
                          }
                          onChange={handleChange}
                          loading={omtOffLoading}
                        />

                        {`agent_${provider.tag.toLowerCase()}` ===
                          selectedAgentValue && (
                          <>
                            {showOtherMobileNumber && !showOrderId && (
                              <Grid2 size={12}>
                                <Card className="myMonty-card">
                                  <Grid2 container sx={{ gap: 2 }} width="80%">
                                    <Grid2
                                      size={12}
                                      display={"flex"}
                                      justifyContent={"start"}
                                    >
                                      <Typography
                                        className="title"
                                        variant="body6"
                                        marginBottom={"3px"}
                                      >
                                        Enter Mobile Number
                                      </Typography>
                                    </Grid2>
                                    <Grid2 size={12}>
                                      <Box>
                                        <div className="phone-input-container">
                                          <PhoneInput
                                            country={countryCode}
                                            countryCodeEditable={false}
                                            value={FormData.mobileNumber || ""}
                                            onChange={handlePhoneChange}
                                            inputStyle={{ width: "100%" }}
                                            specialLabel=""
                                            searchNotFound={
                                              "No Country Found!!"
                                            }
                                            enableSearch={true}
                                            placeholder="Mobile Number"
                                          />
                                        </div>
                                        {showErrorMsg && (
                                          <FormHelperText className="error-styling">
                                            {error}
                                          </FormHelperText>
                                        )}
                                      </Box>
                                    </Grid2>
                                    <Grid2 size={12}>
                                      <Button
                                        fullWidth
                                        disabled={
                                          loading ||
                                          (isOmtCashBrand &&
                                            !FormData?.mobileNumber)
                                        }
                                        id="signIn"
                                        onClick={handleOtherSubmit}
                                        className="submitBtn"
                                      >
                                        {loading ? "Loading..." : "Submit"}
                                      </Button>
                                    </Grid2>
                                  </Grid2>
                                </Card>
                              </Grid2>
                            )}

                            {!showOtherMobileNumber && showOrderId && (
                              <Grid2 size={12}>
                                <Card className="myMonty-card">
                                  <Box margin={"0 auto"} width={"80%"}>
                                    <Grid2 container sx={{ gap: 2 }}>
                                      <Grid2
                                        size={12}
                                        display={"flex"}
                                        justifyContent={"start"}
                                      >
                                        <Typography
                                          className="title"
                                          variant="body6"
                                          marginBottom={"3px"}
                                        >
                                          Order ID
                                        </Typography>
                                      </Grid2>
                                      <Grid2 size={12}>
                                        <TextField
                                          label=""
                                          className="orderId-text-field"
                                          value={paymentOrderId}
                                          disabled={true}
                                          InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <IconButton
                                                  onClick={handleCopy}
                                                >
                                                  <ContentCopyTwoTone />
                                                </IconButton>
                                              </InputAdornment>
                                            ),
                                          }}
                                          fullWidth
                                        />
                                      </Grid2>
                                      {isOmtCashBrand &&
                                        redirectCountdown > 0 && (
                                          <Grid2
                                            size={12}
                                            display="flex"
                                            justifyContent="center"
                                          >
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                mt: 1,
                                                textAlign: "center",
                                              }}
                                            >
                                              Your order ID has been sent to the
                                              mobile number provided.
                                              Redirecting in{" "}
                                              <span
                                                style={{ fontWeight: "bold" }}
                                              >
                                                {redirectCountdown}s
                                              </span>
                                            </Typography>
                                          </Grid2>
                                        )}
                                    </Grid2>
                                  </Box>
                                </Card>
                              </Grid2>
                            )}
                          </>
                        )}
                      </Grid2>
                    ))}
                </>
              )}
            </>
          )}

          {showInvalidTrx && (
            <StatusModal
              paymentStatus="Error"
              statusDescription="No transaction id found. please try again!"
              icon={<CancelIcon sx={{ color: "#f44336", fontSize: 50 }} />}
            />
          )}
          {showMessage && (
            <Grid2
              size={12}
              display={"flex"}
              alignContent={"center"}
              justifyContent={"center"}
            >
              <Typography variant="h4">{paidTrxMsg}</Typography>
            </Grid2>
          )}
          <Grid2
            size={12}
            display={"flex"}
            justifyContent={"center"}
            sx={{ mt: "auto", mb: 1, pt: 2 }}
          >
            <Typography
              variant="caption"
              sx={{ color: "grey", fontSize: "12px" }}
            >
              Version  {appVersion}
            </Typography>
          </Grid2>
        </Grid2>
      )}
    </>
  );
};

export default CheckoutPage;
